<template>
    <div ref="tab_section">
        <div class="tab-area" v-if="ready_to_load">
            <div class="tabs">
                <div class="tabs__list" :class="{'stickytabs': tabsFixed}" ref="tabs_list">
                    <div class="tabs__tab" :class="{'tabs__tab_active': 'transcript' === tabActive}" @click="switchToTranscripts" ><i class="fa fa-file-text-o" aria-hidden="true"></i> Transcript</div>
                    <div class="tabs__tab" :class="{'tabs__tab_active': 'discussion' === tabActive}" @click="switchToDiscussion" ><i class="fa fa-commenting" aria-hidden="true"></i><span class="tab-title">Discussion</span> <span class="tab-comment-count"> ({{ comment_count }})</span></div>
                </div>
                <div class="tabs__container" ref="container">
                    <div class="tabs__wrapper" ref="wrapper">
                        <div class="tabs__content" ref="transcript">
                            <div class="single-tab-inner">
                                <div class="podcast-transcript" ref="podcasttranscript">
                                    <div class="single-sentence" v-for="(group, i) in transcriptGroups" :key="i" :data-group-id="group">
                                        <div v-if="i === 3" id="waldo-tag-24147"></div>
                                        <div v-if="i === 6" id="waldo-tag-24149"></div>
                                        <div v-if="i === 9" id="waldo-tag-24151"></div>
                                        <span class="pod_timestamp_indicator">Starting point is {{getReadableStartingPoint(transcriptChunks, i)}}</span>
                                        <span v-for="chunk in transcriptChunks.slice(i * sentence_wrap, (i + 1) * sentence_wrap)" :key="Math.round(chunk.timestamp[0])" :id="'sentenceid_'+Math.round(chunk.timestamp[0])" :class="(scroll_to_words && chunk.text.toLowerCase().includes(scroll_to_words.join(' ').toLowerCase())) ? 'pod_text found-search' : ''" class="pod_text seek_pod_segment sentence-tooltip transcript-text" v-on:click="handleSentenceClick(chunk.timestamp[0], $event)">
                                            {{ chunk.text }}
                                            <span v-if="checkHasComments(chunk.timestamp[0])" class="has-comments"><i class="fa fa-comments" aria-hidden="true"></i>{{ getCommentCount(chunk.timestamp[0]) }}</span>

                                            <span v-if="tooltip_active === chunk.timestamp[0]" class="tooltip-expanded" :class="{'tooltip-expanded-active' : tooltip_active === chunk.timestamp[0]}">
                                                <span class="pod-play-icon" v-on:click.stop.prevent="playFromHere(chunk.timestamp[0])"><i class="fa fa-play" aria-hidden="true"></i></span>
                                                <span class="pod-pause-icon" v-if="isPlaying" v-on:click.stop.prevent="pausePlayer()"><i class="fa fa-pause" aria-hidden="true"></i></span>
                                                <span class="pod-comment-area" v-on:click.stop.prevent="commentClicked(chunk.timestamp[0], false)"><i class="fa fa-commenting" aria-hidden="true"></i></span>
                                                <span class="pod-comment-area" v-if="checkHasComments(chunk.timestamp[0])" v-on:click="hasCommentsClick(chunk.timestamp[0])" ><i class="fa fa-comments" aria-hidden="true"></i>{{ getCommentCount(chunk.timestamp[0]) }}</span>
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tabs__content" ref="discussion">
                            <div class="single-tab-inner">
                                <div class="discussion-area" id="discussion">
                                    <div v-if="typeof this.episode.comments !== 'undefined' && Object.keys(episode.comments).length > 0">
                                        <div class="single-comment comment-chain" v-for="(comment_groups, group_indexes) in episode.comments" :id="'comment_sentence_id_'+comment_groups[0].sentence_id">
                                            <h4>{{ getSentenceById(comment_groups[0].sentence_id).text }}</h4>
                                            <span class="comment-click-back" v-on:click="transcriptSentence(comment_groups[0].sentence_id)"><i class="fa fa-long-arrow-left" aria-hidden="true"></i></span>
                                            <span class="comment-click" v-on:click.stop.prevent="playFromHere(comment_groups[0].sentence_id)"><i class="fa fa-play" aria-hidden="true"></i></span>
                                            <div v-for="(comment_group, group_index) in comment_groups" v-if="comment_group.comment_id === null">
                                                <div class="comments-group">
                                                    <div class="reviews-comments-item">
                                                        <div class="reviews-comments-item-text">
                                                            <p>{{ comment_group.user_name }} <span class="reviews-comments-item-date"><i class="fa fa-calendar-check-o"></i>{{ getDiffForHumans(comment_group.created_at) }}</span></p>
                                                            <div class="clearfix"></div>
                                                            <h3>{{ comment_group.comment }}</h3>
                                                            <span class="pod-comment-area" v-on:click.stop.prevent="commentClicked(comment_group.sentence_id, true, comment_group.id)"><i class="fa fa-reply-all" aria-hidden="true"></i></span>
                                                        </div>
                                                        <div class="reviews-comments-item comment-reply" v-for="(comment, comment_index) in comment_group.replies">
                                                            <div class="reviews-comments-item-text">
                                                                <p><span class="user-icon"><i class="fa fa-user" aria-hidden="true"></i></span>{{ comment.user_name }} <span class="reviews-comments-item-date"><i class="fa fa-calendar-check-o"></i>{{ getDiffForHumans(comment.created_at) }}</span></p>
                                                                <div class="clearfix"></div>
                                                                <h3>{{ comment.comment }}</h3>
                                                                <span class="pod-comment-area" v-on:click.stop.prevent="commentClicked(comment.sentence_id, true, comment.id)"><i class="fa fa-reply-all" aria-hidden="true"></i></span>
                                                            </div>
                                                            <div class="reviews-comments-item comment-reply" v-for="reply in comment.more_replies">
                                                                <div class="reviews-comments-item-text">
                                                                    <p><span class="user-icon"><i class="fa fa-user" aria-hidden="true"></i></span>{{ reply.user_name }} replied <span class="reviews-comments-item-date"><i class="fa fa-calendar-check-o"></i>{{ getDiffForHumans(reply.created_at) }}</span></p>
                                                                    <div class="clearfix"></div>
                                                                    <h3>{{ reply.comment }}</h3>
                                                                    <span class="pod-comment-area" v-on:click.stop.prevent="commentClicked(reply.sentence_id, true, reply.id)"><i class="fa fa-reply-all" aria-hidden="true"></i></span>
                                                                </div>
                                                                <div class="reviews-comments-item comment-reply" v-for="reply_inner in reply.replies">
                                                                    <div class="reviews-comments-item-text">
                                                                        <p><span class="user-icon"><i class="fa fa-user" aria-hidden="true"></i></span>{{ reply_inner.user_name }} replied <span class="reviews-comments-item-date"><i class="fa fa-calendar-check-o"></i>{{ getDiffForHumans(reply_inner.created_at) }}</span></p>
                                                                        <div class="clearfix"></div>
                                                                        <h3>{{ reply_inner.comment }}</h3>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <h3>There aren't comments yet for this episode. Click on any sentence in the transcript to leave a comment. </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="is_loading_indicator" v-if="!ready_to_load">
            <div class="example">
                <span class="smooth loading-spinner" />
            </div>
        </div>
        <div class="comment-popup-reference-parent" ref="comment_form">
            <div class="comment-popup-reference" @click.stop="" v-if="clicked_comment">
                <div class="comment-form-container clearfix">
                    <div class="infoBox-close" @click="popupClose()">
                        <i class="fa fa-times"></i>
                    </div>
                    <div v-if="commentSubmitted">
                        <span>Thanks for leaving a comment.</span>
                    </div>
                    <div v-else>
                        <form method="post" enctype="multipart/form-data" class="rate-form ep-comment-form custom-form" @submit.prevent="submitComment">
                            <div class="replying-comment-message" v-if="clicked_comment_text">
                                <span>Replying to</span>
                                <span class="reply-span">{{ clicked_comment_text }}</span>
                            </div>
                            <div class="form-group">
                                <input type="hidden" name="store_id" :value="episode.id">
                            </div>
                            <fieldset>
                                <textarea name="user_comment" cols="40" rows="3" placeholder="Your Comment:" v-model.lazy="user_comment"></textarea>
                            </fieldset>
                            <button class="btn  big-btn  color-bg flat-btn">Submit Comment <i class="fa fa-paper-plane-o" aria-hidden="true"></i></button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="pod-player" :class="{'sticky': stick_player}" id="main_pod_player_parent" ref="main_pod_player_wrapper" v-if="episode">
            <audio controls id="main_pod_player" ref="main_pod_player" v-on:timeupdate="updateCurrentPlayTime">
                <source :src="episode.mp3_path">
            </audio>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment'
export default{
    data(){
        return {
            scroll_to_words: undefined,
            currentTab: 'transcript',
            current_segment_playing: '',
            clicked_sentence: '',
            epLoaded: false,
            loggedIn: undefined,
            user_name: undefined,
            user_id: undefined,
            tooltip_active: undefined,
            main_pod_player: undefined,
            sentence_wrap: 8,
            podcast: undefined,
            episode: undefined,
            pod_id: undefined,
            ep_id: undefined,
            tabsFixed: false,
            isSubmitting: false,
            stick_player: false,
            commentSubmitted: false,
            limitPosition: 0,
            lastPosition: 0,
            ready_to_load: false,
            first_load: true,
            isPlaying: false,
            isReply: false,
            isReplyId: null,
            grouped_comments: {},
            comment_count: 0,
            clicked_comment: undefined,
            clicked_comment_text: undefined,
            user_comment: ''
        }
    },
    directives: {
        click_outside: {
            bind(el, binding, vnode) {
                var vm = vnode.context;
                var callback = binding.value;

                el.clickOutsideEvent = function (event) {
                    if (!(el == event.target || el.contains(event.target))) {
                        return callback.call(vm, event);
                    }
                };
                document.body.addEventListener('click', el.clickOutsideEvent);
            },
            unbind(el) {
                document.body.removeEventListener('click', el.clickOutsideEvent);
            }
        }
    },
    watch: {
        stick_player(val) {
            this.stick_player = val;
        },
        episode(newVal) {
            this.$nextTick(function () {
                if (this.$refs.tab_section) {
                    this.setHeight()
                    this.scrollWrapper()
                    this.limitPosition = this.$refs.tab_section.getBoundingClientRect().top - document.querySelector(".main-header").offsetHeight;
                }
            });
        }
    },
    beforeCreate() {

    },
    created() {
        if(typeof scroll_to_words_init !== 'undefined') {
            if (search_type === 'advanced') {
                this.scroll_to_words = scroll_to_words_init.split(', ');
            } else {
                this.scroll_to_words = scroll_to_words_init.split(' ');
            }
        }
        if(typeof podcast_raw_json !== 'undefined' && typeof episode_raw_json !== 'undefined')
        {
            this.podcast = podcast_raw_json;
            this.episode = episode_raw_json;
            this.ready_to_load = true;
            this.comment_count = episode_raw_json.comment_count;
            if (episode_raw_json && typeof episode_raw_json.comments !== 'undefined') {
                this.groupComments();
            }
        }
    },
    mounted() {
        let _this = this;
        this.main_pod_player = document.getElementById('main_pod_player');
        this.$nextTick(function () {
            if (this.scroll_to_words) {
                setTimeout(function (){
                    _this.scrollSentenceToView(_this.$el.getElementsByClassName("found-search")[0], 'center', 'nearest');
                }, 500);
            }
        });

        this.stick_player = true;

        if (window.podcast_id) {
            this.pod_id = window.podcast_id;
        }
        if (window.episode_id) {
            this.ep_id = window.episode_id;
        }
        if (window.logged_in) {
            this.loggedIn = window.logged_in;
            this.user_name = window.user_name;
            this.user_id = window.user_id;
        }


        this.podcast = podcast_raw_json;
        this.episode = episode_raw_json;
        this.ready_to_load = true;

        
        if (window.scroll_to_words) {
            if (window.search_type === 'advanced') {
                this.scroll_to_words = window.scroll_to_words.split(', ');
            } else {
                this.scroll_to_words = window.scroll_to_words.split(' ');
            }
        }

        window.addEventListener("scroll", this.handleScroll);

        function waitForElement(callback, tries = 0) {
            let num_ran = 0;
            const interval = setInterval(() => {
                const element = document.getElementById('adhesion_desktop_wrapper');
                const element_modile = document.getElementById('adhesion_mobile_wrapper');
                if (element !== null || element_modile !== null || num_ran >= tries ) {
                    clearInterval(interval);
                    callback();
                }
                num_ran++;
            }, 1000);
        }

        // Usage
        waitForElement((element) => {
            if (document.getElementById('adhesion_desktop_wrapper') !== null || document.getElementById('adhesion_mobile_wrapper') !== null) {
                if (document.getElementById('adhesion_mobile_wrapper') !== null) {
                    setTimeout(function(){
                        document.getElementById('main_pod_player_parent').style.bottom = (document.getElementById('adhesion_mobile_wrapper').offsetHeight + 10)+'px';
                    }, 2500);
                } else if (document.getElementById('adhesion_desktop_wrapper') !== null) {
                    setTimeout(function(){
                        document.getElementById('main_pod_player_parent').style.bottom = (document.getElementById('adhesion_desktop_wrapper').offsetHeight + 10)+'px';
                    }, 2500);
                }
            }
        }, 10);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    computed: {
        tabActive() {
            return this.currentTab
        },
        transcriptChunks() {
            if (!this.episode || !this.episode.transcript) {
                return [];
            }
            // Handle case where transcript might be a JSON string
            const transcript = typeof this.episode.transcript === 'string' 
                ? JSON.parse(this.episode.transcript) 
                : this.episode.transcript;
            return transcript && transcript.chunks ? transcript.chunks : [];
        },
        transcriptGroups() {
            if (!this.transcriptChunks || this.transcriptChunks.length === 0) {
                return [];
            }
            return Array.from(Array(Math.ceil(this.transcriptChunks.length / this.sentence_wrap)).keys())
        }
    },
    methods: {
        getDiffForHumans(date) {
            return moment(date, "YYYYMMDD").fromNow();
        },
        scrollSentenceToView(passed_element, block, inline) {
            passed_element.scrollIntoView({ behavior: 'smooth', block: block, inline: inline });
        },
        groupComments() {
            const groupBy = key => array =>
                array.reduce((objectsByKeyValue, obj) => {
                    const value = obj[key];
                    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
                    return objectsByKeyValue;
                }, {});
            const groupByBrand = groupBy('sentence_id');

            this.episode.comments = groupByBrand(this.episode.comments);
        },
        getValueFromTranscript(search_key, search_val) {
            if (!this.transcriptChunks || this.transcriptChunks.length === 0) {
                return [];
            }
            return this.transcriptChunks.filter(obj => {
                return obj.search_key === search_val
            })
        },
        commentClicked(sent_id, is_reply, comment_id = null) {
            this.clicked_comment_text = this.getSentenceById(sent_id).text;
            if (this.loggedIn === 1) {
                this.isReply = is_reply;
                this.isReplyId = comment_id;
                this.clicked_comment = sent_id;
                this.$refs.comment_form.classList.add("comment_form_active")
            } else {
                swal({
                    title: "Sorry",
                    text: "You must be signed in to leave a comment",
                    type: "warning",
                    timer: 2000,
                    showConfirmButton: false
                });
            }
        },
        tooltipsClose() {
            this.tooltip_active = undefined;
        },
        handleSentenceClick(curr_time, event) {
            if (this.tooltip_active !== curr_time) {
                this.tooltipsClose();
                this.tooltip_active = curr_time;
            } else {
                this.tooltipsClose();
            }
            let sent_width = (event.currentTarget.offsetWidth / 2);
            if (typeof document.querySelectorAll(".tooltip-expanded")[0] !== 'undefined' && event.currentTarget.offsetLeft > sent_width) {
                console.log(document.querySelectorAll(".tooltip-expanded")[0]);
                document.querySelectorAll(".tooltip-expanded")[0].style.left = 'auto';
                document.querySelectorAll(".tooltip-expanded")[0].style.right = '10px';
            }
        },
        switchToTranscripts() {
            let _this = this;
            _this.tooltipsClose();
            this.currentTab = 'transcript'
            if (this.lastPosition > this.limitPosition) {
                this.$refs.container.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' })
            }
            this.scrollWrapper()

            if (typeof this.episode.comments !== 'undefined' && this.scroll_to_words) {
                document.querySelectorAll(".found-search")[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' })
            }
            this.setHeight();
        },
        switchToDiscussion() {
            let _this = this;
            _this.tooltipsClose();
            this.currentTab = 'discussion'
            if(this.first_load) {
                this.first_load = false;
            }
            if (this.lastPosition > this.limitPosition) {
                this.$refs.container.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' })
            }
            this.setHeight();
            this.scrollWrapper()
        },

        hasCommentsClick(curr_time) {
            this.tooltipsClose();
            this.switchToDiscussion()
            let elems = document.querySelectorAll(".comment-chain");
            [].forEach.call(elems, function(el) {
                el.classList.remove("clicked_through_comment");
            });
            document.querySelector("#comment_sentence_id_"+curr_time).classList.add('clicked_through_comment')
            this.scrollSentenceToView(document.querySelector("#comment_sentence_id_"+curr_time), 'center', 'center');
        },
        transcriptSentence(curr_time) {
            let _this = this;

            _this.tooltipsClose();
            _this.currentTab = 'transcript'
            this.setHeight();
            _this.scrollWrapper()
            _this.scrollSentenceToView(document.querySelector("#sentenceid_"+curr_time), 'center', 'center');
            /*setTimeout(function (){
                _this.scrollSentenceToView(document.querySelector("#sentenceid_"+curr_time), 'center', 'center');
            }, 500);*/
        },
        playFromHere(curr_time) {
            this.$refs.main_pod_player.currentTime = curr_time;
            this.$refs.main_pod_player.play();
            this.isPlaying = true;
        },
        pausePlayer() {
            this.$refs.main_pod_player.pause();
            this.isPlaying = false;
        },
        submitComment(e) {
            this.isSubmitting = true;
            let formData;
            if (this.isReply) {
                formData = {
                    ep_id: this.episode.id,
                    pod_id: this.pod_id,
                    comment_id: this.isReplyId,
                    ep_path: location.pathname,
                    sentence_id: this.clicked_comment,
                    user_name: this.user_name,
                    user_id: this.user_id,
                    comment: this.user_comment,
                }
            } else {
                formData = {
                    ep_id: this.episode.id,
                    pod_id: this.pod_id,
                    ep_path: location.pathname,
                    sentence_id: this.tooltip_active,
                    user_name: this.user_name,
                    user_id: this.user_id,
                    comment: this.user_comment,
                }
            }

            axios.get('/sanctum/csrf-cookie').then(response => {
                axios.post('/api/submitcomment/', formData)
                    .then(response => {
                        if (response.data.status === 'success' && response.data.message === 'comment_added') {
                            this.user_comment = '';
                            this.fetchEpisode();
                            this.isSubmitting = false;
                            this.commentSubmitted = true;
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            });

        },
        fetchEpisode() {
            let _this = this;
            let ep_data = this.episode.episode_url_slug.split("/");
            axios.get('/episodesingle',{params: {pod_id: ep_data[1], ep_id: ep_data[2]}}).then(response => {
                this.episode = response.data.episode;
                this.epLoaded = true;
                this.comment_count = response.data.episode.comment_count;
                this.groupComments();
                this.ready_to_load = true;
            });
        },
        longPressed() {
            console.log('longpressed ');
        },
        getCommentCount(sent_id) {
            if (this.episode.comments[sent_id]) {
                return this.episode.comments[sent_id].length;
            }
        },
        checkHasComments(sent_id) {
            let is_true = false;
            if (typeof this.episode.comments !== 'undefined' && this.episode.comments[sent_id]) {
                is_true = true;
            }
            return is_true;
        },
        getReadableStartingPoint(chunks, index) {
            if (!chunks || chunks.length === 0) {
                return '00:00:00';
            }
            let date = new Date(0);
            const chunk = chunks.slice(index * this.sentence_wrap, (index + 1) * this.sentence_wrap)[0];
            if (chunk && chunk.timestamp && Array.isArray(chunk.timestamp) && chunk.timestamp[0] !== undefined) {
                date.setSeconds(chunk.timestamp[0]);
                let timeString = date.toISOString().substring(11, 19);
                return timeString;
            }
            return '00:00:00';
        },
        popupClose() {
            this.clicked_comment = undefined;
            this.$refs.comment_form.classList.remove("comment_form_active")
            this.commentSubmitted = false;
        },
        updateCurrentPlayTime() {
            this.current_segment_playing = Math.round(this.$refs.main_pod_player.currentTime);
            if(document.getElementById("sentenceid_"+this.current_segment_playing)) {
                let elems = document.querySelectorAll(".seek_pod_segment");
                [].forEach.call(elems, function(el) {
                    el.classList.remove("currently-playing");
                });
                document.getElementById("sentenceid_"+this.current_segment_playing).classList.add('currently-playing');
            }
        },
        getSentenceById(sentence_id) {
            if (!this.transcriptChunks || this.transcriptChunks.length === 0) {
                return null;
            }
            return this.transcriptChunks.find(x => x.timestamp && Array.isArray(x.timestamp) && Math.round(x.timestamp[0]) === sentence_id)
        },
        setHeight() {
            if(!this.first_load) {
                this.$refs.container.style.height = this.$refs[this.currentTab].scrollHeight + 'px'
            }
        },
        scrollWrapper() {
            const offset = this.currentTab === "transcript" ? 0 : 100;
            this.$refs.wrapper.style.transform = `translate3d(-${offset}%, 0, 0)`
        },

        handleScroll() {
            if (this.ready_to_load) {
                let tabs_list = document.querySelector(".tabs__list");
                let tabs__container = document.querySelector(".tabs__container");

                if (window.scrollY >= this.limitPosition) {
                    this.tabsFixed = true;
                    this.$refs.tabs_list.classList.add('stickytabs');
                }
                if (this.lastPosition < window.scrollY && this.limitPosition < window.scrollY && !this.$refs.tabs_list.className.includes('stickytabs') || this.lastPosition < this.$refs.container.getBoundingClientRect().height) {
                    //this.$refs.tabs_list.classList.add('stickytabs');
                    this.tabsFixed = true;
                    this.$refs.tabs_list.style.maxWidth = this.$refs.wrapper.clientWidth + 'px'
                } else if (this.lastPosition > window.scrollY || this.lastPosition < this.limitPosition) {
                    this.$refs.tabs_list.classList.remove('stickytabs');
                }
                if (this.lastPosition > this.$refs.container.getBoundingClientRect().height || this.lastPosition < this.limitPosition) {
                    this.$refs.tabs_list.classList.remove('stickytabs');
                }

                if (this.lastPosition < window.scrollY && this.limitPosition < window.scrollY && !this.$refs.main_pod_player_wrapper.className.includes('sticky') || this.lastPosition < this.$refs.main_pod_player_wrapper.getBoundingClientRect().height) {
                    this.$refs.main_pod_player_wrapper.classList.add('sticky');
                }
                if ( (window.scrollY + document.querySelector(".main-header").offsetHeight) > document.querySelector(".main-footer").offsetTop ) {
                    console.log('going past');
                    this.stick_player = false;
                }
                this.lastPosition = window.scrollY;
            }
        }
    }
}
</script>
